import Vue from 'vue';

const state = {
    order: {
        customer: {},
        cashier: {},
        items: []
    },
    orders: [],
}
const actions = {
    showOrders: (context) => {
        return new Promise((resolve, reject) => {
            axios.get(`/api/orders`).then(response => {
                context.commit('SHOW_ORDERS', response.data)
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    showOrder: (context, id) => {
        return new Promise((resolve, reject) => {
            axios.get(`/api/orders/${id}`).then(response => {
                context.commit('SHOW_ORDER', response.data.data)
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    storeOrder: (context, payload) => {
        return new Promise((resolve, reject) => {
            axios.post(`/api/orders`, payload).then(response => {
                context.commit('STORE_ORDER', response.data)
                Vue.$toast.success("Venda registrada com sucesso!", {
                    position: "top-center" // Pode ser 'top-left', 'top-center', 'bottom-left', 'bottom-center', 'bottom-right'
                });

                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    updateOrder: (context, payload) => {
        return new Promise((resolve, reject) => {
            axios.put(`/api/orders/${payload.id}`, payload).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    destroyOrder: (context, id) => {
        return new Promise((resolve, reject) => {
            axios.delete(`/api/orders/${id}`).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    }
}
const mutations = {

    SHOW_ORDER: (state, payload) => {
        state.order = payload
    },
    SHOW_ORDERS: (state, payload) => {
        state.orders = payload
    },
    STORE_ORDER: (state, payload) => {
        state.order = payload
    }
}
const getters = {
    order: state => {
        return state.order
    },
    orders: state => {
        return state.orders
    }
}
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}